<script>
export default {
  name: 'ListaReboquesMap',
  props: ['opened', 'reboquistas'],
  data () {
    return {
      search: ''
    }
  },
  computed: {
    filteredReboquistas () {
      if (!this.search) return [...this.reboquistas]
      const fields = ['nome', 'id']
      const lower = v => String(v).toLowerCase()

      return this.reboquistas.filter(r => {
        return fields.some(field => lower(r[field]).includes(lower(this.search)))
      })
    }
  },
  methods: {
    possuiGrvsPendentes (reboquista) {
      return !!reboquista.grvs.length
    },
    focarReboquista (reboquista) {
      this.$emit('focarReboquista', reboquista)
      setTimeout(() => {
        this.search = ''
      }, 300)
    }
  }
}
</script>

<template>
  <div class="c-lista-reboques-map" :class="{'open': opened}">
    <div class="c-a-body">
      <input type="text" v-model="search" placeholder="Digite o nome ou ID para filtrar" />
      <ul>
        <li v-for="reboquista in filteredReboquistas" @click="focarReboquista(reboquista)">
          <div style="flex: 1">
            <i class="fa fa-user-circle fa-3x" :class="{'text-info': !possuiGrvsPendentes(reboquista), 'text-danger': possuiGrvsPendentes(reboquista)}"></i>
          </div>
          <div style="flex: 3">
            <strong>
              {{reboquista.nome}}
              <br>
              (ID: {{reboquista.id}})
            </strong>
            <br>
            <small>{{reboquista.grvs.length}} {{reboquista.grvs.length === 1 ? 'GRV pendente' : 'GRVs pendentes'}}</small>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped lang="scss">
.c-lista-reboques-map {
  background: #f1f2f6;
  border-radius: 5px;
  -webkit-box-shadow: 0 2px 14px 0 rgba(97, 123, 160, .4);
  box-shadow: 0 2px 14px 0 rgba(97, 123, 160, .4);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  height: calc(100vh - 80px);
  opacity: 0;
  padding-bottom: 70px;
  position: fixed;
  width: 500px;
  z-index: -1;
  -webkit-transition: all .3s ease;
  transition: all .3s ease;
  right: 150px;
  overflow: auto;

  &.open {
    bottom: 25px !important;
    opacity: 1;
    z-index: 11!important;
    -webkit-transition: all .3s ease;
    transition: all .3s ease;
  }

  .c-a-body{
    padding: 5px;

    input {
      border: none;
      background-color: #dfdfdf;
      border-radius: 15px;
      width: 100%;
      padding: 10px;
      outline: none !important;
      margin: 10px auto;
      text-transform: uppercase;
      text-align: center;

      &::placeholder {
        font-style: italic;
      }
      &:focus {
        border: 1px solid darkgrey;
      }
    }

    ul {
      position: relative;
      list-style: none;
      width: 100%;
      padding: 0;
      margin: 0;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;

      li {
        padding: 12px;
        width: 150px;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2),
        0 1px 3px rgba(0, 0, 0, 0.16);
        margin: 3px;
        background-color: whitesmoke;

        &:hover {
          cursor: pointer;
          background-color: #dfdfdf;
          transition: background-color ease-in-out .1s;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ListaReboquesMap.vue?2bbc1bcc